export default __webpack_public_path__ + "static/media/whatsapp-blue.38c355ef.svg";